import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-loan-checkbox',
    templateUrl: './loan-checkbox.component.html',
    styleUrl: './loan-checkbox.component.scss',
    standalone: false
})
export class LoanCheckboxComponent {
    @Input() text: string = '';
    @Input({ required: true }) groupName!: string;
    @Input() questionText?: string;
    @Input({ required: true }) control!: FormControl;

    get isRequired(): boolean {
        return this.control.hasValidator(Validators.required) || this.control.hasValidator(Validators.requiredTrue);
    }
}
